<template>
  <div class="sidearm-mm-background-element absolute">
    <div
      class="sidearm-mm-background-element__icon absolute"
      v-for="n in 4"
      :key="n"
    >
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
      >
        <g opacity="0.4">
          <path d="M11.5 0H12.5V10H11.5V0Z" fill="white" />
          <path d="M10 12.5V11.5H0V12.5H10Z" fill="white" />
          <path d="M24 12.5V11.5H14V12.5H24Z" fill="white" />
          <path d="M12.5 14H11.5V24H12.5V14Z" fill="white" />
        </g>
      </svg>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.sidearm-mm-background-element {
  background: url("~@/assets/repeater_bg.png") top left repeat;
  &__icon {
    &:first-child {
      top: 24px;
      left: 24px;
    }
    &:nth-child(2) {
      top: 24px;
      right: 24px;
    }
    &:nth-child(3) {
      bottom: 24px;
      left: 24px;
    }
    &:last-child {
      bottom: 24px;
      right: 24px;
    }
  }
}
</style>
